module.exports = __webpack_public_path__ + "img/pin-fill-red.9efa2dfe.svg";